import Cses from "@/pages/Cses";
import DelayedDeliveries from "@/pages/DelayedDeliveries";
import LostDeliveries from "@/pages/LostDeliveries";
import SentBackDeliveries from "@/pages/SentBackDeliveries";
import Deliveries from "@/pages/Deliveries";
import DeliveriesCollected from "@/pages/DeliveriesCollected";
import DeliveriesNew from "@/pages/DeliveriesNew";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import DeliveriesForScanner from "./pages/DeliveriesForScanner";

const routes = [
  {
    component: Deliveries,
    exact: true,
    name: "Deliveries",
    nav: true,
    path: "/deliveries",
    private: true,
  },
  {
    component: DeliveriesCollected,
    exact: true,
    name: "DeliveriesCollected",
    nav: true,
    path: "/deliveries-collected",
    private: true,
  },
  {
    component: DeliveriesNew,
    exact: true,
    name: "DeliveriesNew",
    nav: true,
    path: "/deliveries-new",
    private: true,
  },
  {
    component: DelayedDeliveries,
    exact: true,
    name: "DelayedDeliveries",
    nav: true,
    csCommunication: true,
    path: "/delayed-deliveries",
    private: true,
  },
  {
    component: Cses,
    exact: true,
    name: "Cses",
    nav: true,
    csCommunication: true,
    path: "/cses",
    private: true,
  },
  {
    component: SentBackDeliveries,
    exact: true,
    name: "SentBackDeliveries",
    nav: true,
    csCommunication: true,
    path: "/sent-back-deliveries",
    private: true,
  },
  {
    component: LostDeliveries,
    exact: true,
    name: "LostDeliveries",
    nav: true,
    csCommunication: true,
    path: "/lost-deliveries",
    private: true,
  },
  {
    component: Login,
    exact: true,
    name: "Login",
    path: "/",
  },
  {
    component: Profile,
    exact: true,
    name: "Profile",
    nav: true,
    path: "/profile",
    private: true,
  },
  {
    component: DeliveriesForScanner,
    exact: true,
    name: "DeliveriesForScanner",
    nav: true,
    path: "/deliveries-for-scanner",
    private: true,
  },
];

export default routes;
